/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_SubtitleInputs */

const en_home_subtitle = /** @type {(inputs: Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviced apartments, booked directly. No middleman, instant confirmation.`)
};

/**
* | output |
* | --- |
* | "Serviced apartments, booked directly. No middleman, instant confirmation." |
*
* @param {Home_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_subtitle = /** @type {((inputs?: Home_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_subtitle(inputs)
});